export default __webpack_public_path__ + "static/media/syncpay.alt.f4c60d42.png";